import React, { Component } from "react";
import { View, Dimensions, Platform } from "react-native";
import Text from "./TextFont";
import { BarChart } from "react-native-chart-kit"; // has issue with persian text
import {
  BarChart as WBarChart,
  YAxis,
  Grid,
} from "react-native-web-svg-charts";

import PropTypes from "prop-types";
import { getIsRTL } from "../util";

const SCREEN_WIDTH = Dimensions.get("screen").width;
const IS_MOBILE = Platform.OS === "android" || Platform.OS == "ios";
const chartColors = {
  backgroundColor: "#e26a00",
  backgroundGradientFrom: "#fb8c00",
  backgroundGradientTo: "#ffa726",
};
/**@augments{Component<props,state>} */
class NativeBarChart extends Component {
  render() {
    let {
      data,
      backgroundGradientTo,
      backgroundGradientFrom,
      backgroundColor,
    } = this.props;
    if (!backgroundGradientTo)
      backgroundGradientTo = chartColors.backgroundGradientTo;
    if (!backgroundGradientFrom)
      backgroundGradientFrom = chartColors.backgroundGradientFrom;
    if (!backgroundColor) backgroundColor = chartColors.backgroundColor;
    var labels = data.map((cd, idx) =>
      idx % 2 == 1 && ((cd.label && cd.label.length > 2) || data.length > 10)
        ? ""
        : cd.label
    );
    if (!data) {
      return null;
    }
    if (IS_MOBILE) {
      return (
        <BarChart
          data={{
            labels,
            datasets: [
              {
                data: [...data.map((cd) => cd.value)],
              },
            ],
          }}
          width={SCREEN_WIDTH - 20} // from react-native
          height={200}
          yAxisLabel=""
          yAxisSuffix=""
          yAxisInterval={1} // optional, defaults to 1
          fromZero={data.some((d) => d.value < 10)}
          chartConfig={{
            data,
            barPercentage:
              data && data.length > 0
                ? (1 / data.length) * 7 // calculated width as 70% of width divided by columns count
                : 0.5, // or default as 0.5
            backgroundColor,
            backgroundGradientFrom,
            backgroundGradientTo,
            decimalPlaces: 2, // optional, defaults to 2dp
            color: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
            labelColor: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
            style: {
              borderRadius: 6,
              marginHorizontal: 10,
              paddingHorizontal: 10,
            },
            propsForDots: {
              r: "6",
              strokeWidth: "2",
              stroke: "#ffa726",
            },
            propsForLabels: {
              //transform: "rotate(90)",
            },
          }}
          bezier
          style={{
            marginVertical: 8,
            borderRadius: 6,
          }}
        />
      );
    } else {
      var contentInset = { top: 30, bottom: 10 };
      return (
        <View
          style={{
            flexDirection: "row",
            height: 200,
            backgroundColor: backgroundGradientTo,
            padding: 1,
          }}
        >
          <View style={{ flex: 1 }}>
            <WBarChart
              style={{
                height: 180,
                flex: 1,
              }}
              data={data} // .map((cd) => cd.value)
              yAccessor={({ item }) => item.value}
              xAccessor={({ item }) => item.label}
              svg={{ fill: backgroundColor }}
              contentInset={contentInset}
            >
              <Grid
                svg={{
                  stroke: "#FFF",
                  strokeOpacity: 0.2,
                  strokeDasharray: "7 7",
                }}
              />
            </WBarChart>
            <View
              style={{
                flexDirection: getIsRTL() ? "row-reverse" : "row",
                justifyContent: "space-between",
              }}
            >
              {labels.map((l, i) => (
                <Text
                  style={{
                    textAlign: "center",
                    color: "#FFF",
                    width:
                      labels.length > 0 ? SCREEN_WIDTH / labels.length : 15,
                  }}
                  key={i}
                >
                  {l}
                </Text>
              ))}
            </View>
            {/* XAxis failed to render */}
            {/* <XAxis
                style={{
                  marginHorizontal: 10,
                  borderWidth: 1,
                  borderColor: "red",
                  height: 20,
                }}
                data={data}
                xAccessor={({ item }) => item.label}
                formatLabel={(value, index) => value}
                              contentInset={contentInset}

                fontSize={10}
                fill="black"
              /> */}
          </View>
          <YAxis
            style={{ paddingHorizontal: 10 }}
            data={[...data.map((cd) => cd.value)]}
            contentInset={contentInset}
            fill="#FFF"
            fontSize={12}
            numberOfTicks={5}
            //formatLabel={(value) => `${value}ºC`}
          />
        </View>
      );
    }
  }
}

NativeBarChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  backgroundColor: PropTypes.string,
  backgroundGradientFrom: PropTypes.string,
  backgroundGradientTo: PropTypes.string,
};

export default NativeBarChart;
